import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa'; // Importa o ícone do WhatsApp do react-icons/fa
import Logo from '../../assets/imgs/logo.webp'; // Importa a sua logo
import { useWhatsApp } from '../../context/WhatsAppContext';

const navLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Planos', href: '#planos' },
  { label: 'Benefícios', href: '#beneficios' },
  { label: 'Cobertura', href: '#cobertura' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'FAQ', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { openWhatsAppModal } = useWhatsApp();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled
          ? 'bg-background/80 backdrop-blur-xl border-b border-border/30'
          : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <button onClick={() => scrollTo('#hero')} className="flex items-center gap-2.5 group">
            <img src={Logo} alt="WebNorte Logo" className="w-12 h-12 object-contain invert" /> {/* Aumenta o tamanho da logo */}
            <span className="font-poppins font-bold text-lg tracking-tight text-foreground">
              Web<span className="gradient-text">Norte</span>
            </span>
          </button>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="font-inter text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <button
            onClick={openWhatsAppModal}
            className="hidden lg:flex items-center gap-2 px-5 py-2.5 rounded-full bg-success text-white font-inter font-medium text-sm hover:bg-success/90 transition-colors"
          >
            <FaWhatsapp className="w-5 h-5" /> Falar no WhatsApp {/* Adiciona o ícone do WhatsApp do react-icons/fa */}
          </button>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 text-foreground"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="lg:hidden bg-background/95 backdrop-blur-xl border-b border-border/30 overflow-hidden"
          >
            <div className="px-6 py-6 space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  className="block w-full text-left font-inter text-base text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.label}
                </button>
              ))}

              <button
                onClick={openWhatsAppModal}
                className="block w-full text-center mt-4 px-5 py-3 rounded-full bg-success text-white hover:bg-success/90 transition-colors font-inter font-medium text-sm"
              >
                <FaWhatsapp className="w-5 h-5 inline-block mr-2" /> Falar no WhatsApp {/* Adiciona o ícone do WhatsApp do react-icons/fa */}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

    </header>
  );
}